import map from 'lodash/map';
import filter from 'lodash/filter';
import unionBy from 'lodash/unionBy';
import { resolveErrorMessage } from 'modules/errors';
import {
  postInvitation,
  fetchProducerInvitations,
  fetchTalentInvitations,
} from './api';
import {
  createAsyncThunk,
  createSlice,
  createSelector,
} from '@reduxjs/toolkit';

export const loadProducerInvitations = createAsyncThunk(
  'auditionsInvitations/producerInvitations',
  async ({ producerId, auditionId }) =>
    await fetchProducerInvitations(producerId, auditionId),
);

// TODO: not used anywhere?
export const loadTalentInvitations = createAsyncThunk(
  'auditionsInvitations/talentInvitations',
  async talentId => await fetchTalentInvitations(talentId),
);

export const inviteTalent = createAsyncThunk(
  'auditionsInvitations/createInvite',
  async ({ producerId, auditionId, talentIds, message }) =>
    await postInvitation(producerId, auditionId, talentIds, message),
);

const auditionsInvitationsSlice = createSlice({
  name: 'auditionsInvitations',
  initialState: {
    error: null,
    loading: false,
    invitations: [],
  },
  reducers: {
    removeInviteErrorAction: state => {
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(loadProducerInvitations.pending, (state, _) => {
        state.loading = true;
      })
      .addCase(loadProducerInvitations.fulfilled, (state, action) => {
        state.invitations = action.payload.data;
        state.loading = false;
      })
      .addCase(loadProducerInvitations.rejected, (state, _) => {
        state.loading = false;
      })
      .addCase(inviteTalent.fulfilled, (state, action) => {
        const newInvitations = map(
          action.payload,
          invitation => invitation.data,
        );

        state.invitations = unionBy(newInvitations, state.invitations, 'id');
        state.error = null;
      })
      .addCase(inviteTalent.rejected, (state, action) => {
        state.error = resolveErrorMessage(action.error);
      })
      .addCase(loadTalentInvitations.pending, (state, _) => {
        state.loading = true;
      })
      .addCase(loadTalentInvitations.fulfilled, (state, action) => {
        const newInvitations = map(
          action.payload,
          invitation => invitation.data,
        );

        state.loading = false;
        state.invitations = unionBy(newInvitations, state.invitations);
      })
      .addCase(loadTalentInvitations.rejected, (state, _) => {
        state.loading = false;
      });
  },
  selectors: {
    getInviteError: state => state.error,
    getInvitations: state => state.invitations,
    getInvitationsLoading: state => state.loading,
  },
});

export const reducer = auditionsInvitationsSlice.reducer;
export const { removeInviteErrorAction } = auditionsInvitationsSlice.actions;
export const { getInvitations, getInviteError, getInvitationsLoading } =
  auditionsInvitationsSlice.selectors;

export const getInvitationsByAuditionId = auditionId =>
  createSelector(getInvitations, invitations =>
    filter(invitations, invitation => invitation.auditionId === auditionId),
  );
